import { combineReducers } from 'redux';
import loginReducer from 'src/common/redux/reducers/userDetails';
import devReducer from 'src/common/redux/reducers/devReducer';
import BarCodeScannerReducer from 'src/common/barCodeScannerRedux/reducer';
import qrCodeReducer from 'src/common/redux/reducers/qrCodeReducer.js';
import timerReducer from 'src/common/redux/timerReducer';
import batchExportReducer from 'src/common/redux/reducers/batchExportReducer';

import {
    ordersReducer,
    filterReducer,
    navLinkReducer,
    refinedFiltersReducer,
    viewFilterReducer,
    appliedFiltersReducer,
    setfilterOptionsReducer,
    userProfileReducer,
    pageVisibilityRuleReducer,
} from 'src/pages/home/redux/reducers';
// schedule surgery related reducers
import {
    surgeryReducer,
    detailsDropdownsReducer,
    productsSearchReducer,
    productsGuideReducer,
    validateProductsReducer,
    storeAddItemDataReducer,
    productTemplatesFilterReducer,
    progressBarReducer,
    productDetailsReducer,
    shipToAddressReducer,
    shippingMethodsReducer,
    shippingBatchAllocation,
    createSurgeryReducer,
    surgeryDetailsReducer,
    updateSurgeryReducer,
    productTemplatesReducer,
    commonReducer,
    surgeryvalidateAccountReducer,
    surgeryvalidateBillToReducer,
    checkProductBomReducer,
    transferRecipientReducerSchedule
} from 'src/pages/scheduleSurgery/redux/reducers';

import {
    equityReducer,
    equityDetailsDropdownsReducer,
    equityProductsGuideReducer,
    equityValidateProductsReducer,
    equityProductsSearchReducer,
    equityProductTemplatesFilterReducer,
    equityProgressBarReducer,
    equityProductDetailsReducer,
    equityShipToAddressReducer,
    equityShippingMethodsReducer,
    // shippingBatchAllocation,
    // createSurgeryReducer,
    // surgeryDetailsReducer,
    // updateSurgeryReducer,
    equityProductTemplatesReducer,
    equityCommonReducer,
    equityDetailsReducer,
    createEquityReducer,
    validateAccountReducer,
    equityCartDetailsReducer,
    getPricesForItemsReducer,
    getStoreItemTableDataReducer,
    updateEquityReducer,
    equityDetailsDataReducer,
    equityPriceOverrideReducer,
} from 'src/pages/equity/redux/reducers';

import {
    consignmentAddProductGuideReducer,
    consignmentAddProductTemplatesReducer,
    consignmentAddCommonReducer,
    consignmentAddDetailsReducer,
    createConsignmentAddReducer,
    validateConsignmentAccountReducer,
    consignmentAddCartDetailsReducer,
    getStoreItemTableDataReducerConsignmentAdd,
    updateConsignmentAddReducer,
    consignmentAddDetailsDataReducer,
    consignmentAddPriceOverrideReducer,
    consignmentAddReducer,
    consignmentAddDetailsDropdownsReducer,
    consignmentAddValidateProductsReducer,
    consignmentAddProductsSearchReducer,
    consignmentAddProductTemplatesFilterReducer,
    consignmentAddProgressBarReducer,
    consignmentAddProductDetailsReducer,
    consignmentAddShipToAddressReducer,
    consignmentAddShippingMethodsReducer,
    transferRecipientReducerConsignmentAdd
} from 'src/pages/consignmentAdd/redux/reducers';

import {
    consignmentBilling,
    consignmentReducer,
    consignmentCommonReducer,
    consignmentDetailsReducer,
    inventoryReducer,
    gridDataReducer,
    //shipToAddressReducer,
    consignmentShipToAddressReducer,
    updateConsignmentReducer,
    createConsignmentReducer,
    paymentDataReducer,
    consignmentDetailsDropdownsReducer,
    getPricesForItemsConsignmentReducer,
    consignmentProgressBarReducer,
    transferRecipientReducerConsignmentBilling,
    validateProductsReducerBilling
} from 'src/pages/consignmentBilling/redux/reducers';

import {
    consignmentReturnReducer,
    returnDetailsDropdownsReducer,
    InventoryReturnReducer,
    consignmentReturnDetailsReducer,
    consignmentReturnProgressBarReducer,
    consignmentReturnRootReducer,
    consignmentReturnOrderReducer,
} from 'src/pages/consignmentReturn/redux/reducers';

import {
    receiveSetsDetailsDropdownsReducer,
    receiveSetsReducer,
    receiveSetsListDataReducer,
    createReceiveSetsReducer,
    receiveSetsProductsSearchReducer,
    receiveSetsProductDetailsReducer,
} from 'src/pages/receiveSets/redux/reducers/index.js';

import {
    templatesReducer,
    getSettingsReducer,
    applySettingReducer,
    announcementReducer,
    accountReducer,
    linksReducer,
    fieldInventoryDashboardReducer,
    dashboardExportReducer,
    fimAddNotesReducer,
    dashboardListReducer,
    allocationDetailsReducer,
    allocateSetReducer,
    rejectSetReducer,
    setDetailsReducer,
    dashboardFiltersReducer,
    rejectSetReasonsReducer,
} from 'src/pages/more/redux/reducer';

import {
    ordersListReducer,
    orderSummaryReducer,
    checkOrderActionEligibilityReducer,
    appliedOrdersSearchReducer,
    orderFilterReducer,
    appliedOrdersFilterReducer,
    legacyMobileFilterReducer,
    deleteOrderReducer,
    sendReportReducer,
    viewReportReducer,
    ViewPdfReportReducer,
    sendInvoiceReducer,
    unidUrlReducer,
    submitProcedureDataReducer,
    ctaDataReducer,
} from 'src/pages/orders/redux/reducers';

import {
    impersonationReducer,
    invalidateImpersonationReducer,
    impersonatedUserDataReducer,
} from 'src/pages/impersonation/redux/reducers';

import replenishAccount from 'src/pages/reportUsage/redux/reducer/replenishAccount';
import reportUsageRootReducer from 'src/pages/reportUsage/redux/reducer';
import reportUsageProgressBarReducer from 'src/pages/reportUsage/redux/reducer/progressBarReducer';
import noUsageToReportReducer from 'src/pages/reportUsage/redux/reducer/noUsageToReportReducer';
import reportShippingMethodsReducer from 'src/pages/reportUsage/redux/reducer/reportShippingMethods';
import reportShipToAddressReducer from 'src/pages/reportUsage/redux/reducer/reportShipToAddress';
import reportUsageShippingDetailsReducer from 'src/pages/reportUsage/redux/reducer/shippingDetailsReducer';
import usageTransferRecipientReducer from 'src/pages/reportUsage/redux/reducer/usageTransferRecipient';

import {
    ProductsGuideReducer,
    ValidateProductsReducer,
    searchProductsReducer,
} from 'src/pages/more/pages/productGuide/redux/reducer';

import {
    ProxyReducer,
    RevokeProxyReducer,
    InitiateProxyReducer,
} from 'src/pages/more/pages/proxies/redux/reducer';

import {
    AdminReducer,
    AdminProxyReducer,
    AdminFilterReducer,
} from 'src/pages/admin/redux/reducer';

import {
    ShareTemplateReducer,
    UpdateTemplateReducer,
    FilterParamReducer,
    ListShareUserReducer,
    CreateTemplateReducer,
    filterTemplateReducer,
    GetTemplateReducer,
    CategoryNameReducer,
    commonTemplateReducer,
    userListReducer,
    templateDetailReducer,
    TypeFilterReducer,
    filterSearchReducer,
} from 'src/pages/more/pages/templates/redux/reducer';
import HeaderNotesReducer from 'src/common/redux/reducers/headerNotesReducer';

const rootReducer = combineReducers({
    TypeFilterReducer,
    templateDetailReducer,
    userListReducer,
    CategoryNameReducer,
    filterTemplateReducer,
    GetTemplateReducer,
    UpdateTemplateReducer,
    FilterParamReducer,
    CreateTemplateReducer,
    devReducer,
    loginReducer,
    ordersReducer,
    filterReducer,
    navLinkReducer,
    refinedFiltersReducer,
    viewFilterReducer,
    appliedFiltersReducer,
    setfilterOptionsReducer,
    userProfileReducer,
    pageVisibilityRuleReducer,
    surgeryReducer,
    replenishAccount,
    detailsDropdownsReducer,
    productsSearchReducer,
    productsGuideReducer,
    validateProductsReducer,
    storeAddItemDataReducer,
    productTemplatesFilterReducer,
    progressBarReducer,
    productDetailsReducer,
    getSettingsReducer,
    ordersListReducer,
    orderSummaryReducer,
    checkOrderActionEligibilityReducer,
    shipToAddressReducer,
    shippingMethodsReducer,
    shippingBatchAllocation,
    createSurgeryReducer,
    surgeryDetailsReducer,
    updateSurgeryReducer,
    appliedOrdersSearchReducer,
    appliedOrdersFilterReducer,
    legacyMobileFilterReducer,
    announcementReducer,
    productTemplatesReducer,
    commonReducer,
    applySettingReducer,
    orderFilterReducer,
    deleteOrderReducer,
    viewReportReducer,
    ViewPdfReportReducer,
    sendReportReducer,
    sendInvoiceReducer,
    unidUrlReducer,
    impersonationReducer,
    invalidateImpersonationReducer,
    impersonatedUserDataReducer,
    reportUsageRootReducer,
    reportUsageProgressBarReducer,
    equityReducer,
    equityDetailsDropdownsReducer,
    equityProductsGuideReducer,
    equityValidateProductsReducer,
    equityProductsSearchReducer,
    equityProductTemplatesFilterReducer,
    equityProgressBarReducer,
    equityProductDetailsReducer,
    equityShipToAddressReducer,
    equityShippingMethodsReducer,
    // equityShippingBatchAllocation,
    // equityCreateSurgeryReducer,
    // equitySurgeryDetailsReducer,
    // equityUpdateSurgeryReducer,
    equityProductTemplatesReducer,
    equityCommonReducer,
    equityDetailsReducer,
    createEquityReducer,
    accountReducer,
    validateAccountReducer,
    surgeryvalidateAccountReducer,
    surgeryvalidateBillToReducer,
    noUsageToReportReducer,
    consignmentProgressBarReducer,
    consignmentReturnProgressBarReducer,
    consignmentBilling,
    equityCartDetailsReducer,
    getPricesForItemsReducer,
    consignmentReducer,
    reportShippingMethodsReducer,
    reportShipToAddressReducer,
    gridDataReducer,
    consignmentCommonReducer,
    consignmentDetailsReducer,
    getStoreItemTableDataReducer,
    inventoryReducer,
    linksReducer,
    fieldInventoryDashboardReducer,
    dashboardExportReducer,
    fimAddNotesReducer,
    dashboardListReducer,
    allocationDetailsReducer,
    allocateSetReducer,
    rejectSetReducer,
    dashboardFiltersReducer,
    ProductsGuideReducer,
    ValidateProductsReducer,
    ProxyReducer,
    RevokeProxyReducer,
    InitiateProxyReducer,
    searchProductsReducer,
    consignmentShipToAddressReducer,
    consignmentReturnReducer,
    returnDetailsDropdownsReducer,
    submitProcedureDataReducer,
    ctaDataReducer,
    updateEquityReducer,
    equityDetailsDataReducer,
    consignmentReturnRootReducer,
    updateConsignmentReducer,
    templatesReducer,
    InventoryReturnReducer,
    createConsignmentReducer,
    AdminReducer,
    AdminFilterReducer,
    equityPriceOverrideReducer,
    consignmentReturnDetailsReducer,
    consignmentReturnOrderReducer,
    AdminProxyReducer,
    paymentDataReducer,
    consignmentDetailsDropdownsReducer,
    ShareTemplateReducer,
    ListShareUserReducer,
    getPricesForItemsConsignmentReducer,
    receiveSetsDetailsDropdownsReducer,
    receiveSetsReducer,
    receiveSetsListDataReducer,
    createReceiveSetsReducer,
    receiveSetsProductsSearchReducer,
    commonTemplateReducer,
    receiveSetsProductDetailsReducer,
    filterSearchReducer,
    reportUsageShippingDetailsReducer,
    usageTransferRecipientReducer,
    consignmentAddProductGuideReducer,
    consignmentAddProductTemplatesReducer,
    consignmentAddCommonReducer,
    consignmentAddDetailsReducer,
    createConsignmentAddReducer,
    validateConsignmentAccountReducer,
    consignmentAddCartDetailsReducer,
    getStoreItemTableDataReducerConsignmentAdd,
    updateConsignmentAddReducer,
    consignmentAddDetailsDataReducer,
    consignmentAddPriceOverrideReducer,
    consignmentAddReducer,
    consignmentAddDetailsDropdownsReducer,
    consignmentAddValidateProductsReducer,
    consignmentAddProductsSearchReducer,
    consignmentAddProductTemplatesFilterReducer,
    consignmentAddProgressBarReducer,
    consignmentAddProductDetailsReducer,
    consignmentAddShipToAddressReducer,
    consignmentAddShippingMethodsReducer,
    checkProductBomReducer,
    BarCodeScannerReducer,
    qrCodeReducer,
    HeaderNotesReducer,
    timerReducer,
    batchExportReducer,
    transferRecipientReducerConsignmentAdd,
    transferRecipientReducerSchedule,
    transferRecipientReducerConsignmentBilling,
    validateProductsReducerBilling,
    setDetailsReducer,
    rejectSetReasonsReducer,
});

export default rootReducer;
